import { Nav, NavItem, NavLink, TabContent, TabPane } from "reactstrap";
import { useAppDispatch, useAppSelector } from "../../../../../../reduxToolkit/hooks";
import { setTabId } from "../../../../../../reduxToolkit/reducers/eCommerce/addProductSlice";
import { AdvancedSettingTabs } from "../../../../../../data/applications/ECommerce";
import Inventory from "./Inventory";
import AdditionalOptions from "./AdditionalOptions";
import Shipping from "./Shipping";

// This component manages advanced settings tabs for adding a product.
const AdvancedSettings = () => {
  const { tabId } = useAppSelector((state) => state.addProduct);
  const dispatch = useAppDispatch();

  return (
    <div className="sidebar-body">
      <Nav className="border-tab mb-0" tabs>
        {AdvancedSettingTabs.map((data, i) => (
          <NavItem key={i}>
            <NavLink active={tabId === i + 1 ? true : false} onClick={() => dispatch(setTabId(i + 1))}>{data}</NavLink>
          </NavItem>
        ))}
      </Nav>
      <TabContent activeTab={tabId}>
        <TabPane tabId={1}>
          <Inventory />
        </TabPane>
        <TabPane tabId={2}>
          <AdditionalOptions />
        </TabPane>
        <TabPane tabId={3}>
          <Shipping />
        </TabPane>
      </TabContent>
    </div>
  );
};

export default AdvancedSettings;